export default {
  mesa: "Table",
  product: "Product",
  quantity: "Quantity",
  price: "Price",
  total: "Account total",
  totalPaid: "Total paid",
  baseTax: "Tax base",
  VAT: "VAT",
  paymentMethod: "Way to pay",
  pagado: "Paid out"
};
